import React from "react";
import LandingPage from "./pages/LandingPage";
import GlobalStyle from "./GlobalStyles";

function App() {
  return (
    <>
      <GlobalStyle />
      <LandingPage />
    </>
  );
}

export default App;
